import { COLOR2, COLOR4, FONT_BOLD_16_18, RADIO_COLOR } from '../../constants';

export const BundleContactStyles = {
  contentContainer: {
    margin: '48px 12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',

    '@media(max-width:600px)': {
      padding: '24px 12px',
      margin: '0px 0px',
    },
  },
  contact_grid_margin: {
    width: 630,
    height: 792,
    top: 65,
    justifyContent: 'space-between',
    transform: 'rotate(0deg)',
    opacity: 1,
    display: 'flex',
    maxWidth: '500px',
    margin: 'auto',
    gap: '12px',
    position: 'relative',
    '@media (max-width:600px)': {
      width: 355,
      height: 650,
      gap: '10px',
      padding: '12px',
      top: 10,
      justifyContent: 'center',
    },
  },
  unity_account_heading: {
    marginBottom: '24px',
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '100%',
    letterSpacing: '0%',
  },

  gridStyles: {
    // width: '100%',
    // marginBottom: '16px',
    // position: 'relative',
    // zIndex: 2,
    // display: 'flex',
    // flexDirection: 'column',
    // gap: '8px',
    '@media (max-width:960px)': {
      paddingRight: '0px',
    },
    '@media(max-width:600px)': {
      width: '100%',
    },
  },

  confirm_details_subheading: {
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '100%',
    letterSpacing: '0%',
    textAlign: 'justify',
    marginBottom: '24px',
    marginRight: '4px',
  },

  form_field_label: {
    fontFamily: 'Arial',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0%',
    borderRadius: '56px',
  },

  form_input_field: {
    border: '1px solid #CCCCCC',
    borderRadius: '56px',
    padding: '12px',
    '&::placeholder': {
      fontFamily: 'TT Norms',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0%',
      color: '#A7A7A7',
      opacity: 1,
    },
  },
  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  consent_container: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '4px',
    marginBottom: '24px',
    gap: '12px',
    '@media (max-width:600px)': {
      height: '48px',
      transform: 'rotate(0deg)',
      opacity: 1,
    },
  },

  info_tooltip_icon: {
    marginRight: '8px',
  },

  consent_text: {
    fontFamily: 'Arial',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0%',
    height: '16px',
    whiteSpace: 'nowrap',
    color: '#444444',
    '@media (max-width:600px)': {
      whiteSpace: 'normal',
    },
  },

  continueButton: {
    fontFamily: 'Arial',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'center',
    borderRadius: '56px',
    padding: '14px 50px',
    opacity: 1,
    width: '100%',
  },
  disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#F3F3F3`,
      border: `#F3F3F3`,
      borderRadius: '56px',
      color: '#D0D0D0',
      width: '630px',
      height: '45px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#F3F3F3',
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
  },
};
